import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { getAuthToken, getUserId } from "../services/authService";

const ProtectedRoute: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const userId = getUserId();
  const token = getAuthToken();
  const location = useLocation();

  if (!userId || !token) {
    // Redirect to login page with the return url
    return <Navigate to="/login" state={{ from: location.pathname }} replace />;
  }

  return <>{children}</>;
};

export default ProtectedRoute;
